import React, { useState, useEffect } from 'react';
import DeactivatedUsersFlowsPage from './DeactivatedUsersFlowsPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';

import {
  get_admin_inactive_users,
  remove_bu_master
} from '../../../redux/slice';
import FormData from 'form-data';

function DeactivatedUsersFlows() {
  TabTitle('Gift Register - Entry Delegator Flows');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const {
    admin_inactive_usersList,
    admin_inactive_usersPagination,
    get_admin_inactive_usersLoading,
    remove_entry_delegatorLoading
  } = useSelector((state) => state.admin);

  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [showDisablePopup, setShowDisablePopup] = useState(false);

  //console.log('searchRequest', searchRequest);
  //console.log(triggerFilter);
  console.log('admin_inactive_usersList', admin_inactive_usersList);

  useEffect(() => {
    handleGetInactiveUsers();
  }, [page, pageSize]);

  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetInactiveUsers();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest]); //page,

  const handleGetInactiveUsers = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest
    };
    dispatch(get_admin_inactive_users(payload));
  };

  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  };*/
  const handleDeleteRequest = (record) => {
    let formdata = new FormData();
    //console.log('record', record?.record);
    formdata.append('isActive', false);
    formdata.append('id', record?.record?.key);

    dispatch(remove_bu_master(formdata)).then(function (response) {
      if (response) {
        handleGetInactiveUsers();
      }
    });
  };
  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <DeactivatedUsersFlowsPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          bu_MasterList={admin_inactive_usersList}
          pagination={admin_inactive_usersPagination}
          get_BU_MasterLoading={get_admin_inactive_usersLoading}
          setSearchRequest={setSearchRequest}
          showDisablePopup={showDisablePopup}
          setShowDisablePopup={setShowDisablePopup}
          handleDeleteRequest={handleDeleteRequest}
          remove_entry_delegatorLoading={remove_entry_delegatorLoading}
          handleGetInactiveUsers={handleGetInactiveUsers}
        />
      </div>
    </CustomLayout>
  );
}
export default DeactivatedUsersFlows;
